// extracted by mini-css-extract-plugin
export default {"container":"zVXlB7nHyLPJZNy0BP9X","description":"jW_rnn9CnrBItY2gXLSk"};